// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropzone_wrapper__oEFFv","placeholder":"Dropzone_placeholder__moVKF","placeholderIcon":"Dropzone_placeholderIcon__mpTla","required":"Dropzone_required__fJtsh"};